export const linearData = {options:{ world:{x1:0, y1:0, x2:14, y2:50}, scale:{start: 0, end: 13.5, increment:0.1, y:9}, segmentHeight:5, verticalDisplayStart: 10 },assets: [
  {
    "id": 1,
    "name": "TIES",
    "start": 0,
    "end": 1.5,
    "text": 16
  },
  {
    "id": 2,
    "name": "TIES",
    "start": 1.5,
    "end": 3.15,
    "text": 5
  },
  {
    "id": 3,
    "name": "TIES",
    "start": 3.15,
    "end": 3.5,
    "text": 5
  },
  {
    "id": 4,
    "name": "TIES",
    "start": 3.5,
    "end": 5.3,
    "text": "12-25%"
  },
  {
    "id": 5,
    "name": "TIES",
    "start": 5.3,
    "end": 7.79,
    "text": 4
  },
  {
    "id": 6,
    "name": "TIES",
    "start": 7.79,
    "end": 11.38,
    "text": 17
  },
  {
    "id": 7,
    "name": "TIES",
    "start": 11.38,
    "end": 12.7,
    "text": "13-10%"
  },
  {
    "id": 8,
    "name": "TIES",
    "start": 12.7,
    "end": 13,
    "text": "13-100%"
  },
  {
    "id": 9,
    "name": "TIES",
    "start": 13,
    "end": 13.4,
    "text": "13-100%"
  }
  ,
  {
    "id": 10,
    "name": "SURFACING",
    "start": 0,
    "end": 1.5,
    "text": 16
  },
  {
    "id": 11,
    "name": "SURFACING",
    "start": 1.5,
    "end": 3.15,
    "text": 5
  },
  {
    "id": 12,
    "name": "SURFACING",
    "start": 3.15,
    "end": 3.5,
    "text": 5
  },
  {
    "id": 13,
    "name": "SURFACING",
    "start": 3.5,
    "end": 4.7,
    "text": 12
  },
  {
    "id": 14,
    "name": "SURFACING",
    "start": 4.7,
    "end": 5.3,
    "text": 12
  },
  {
    "id": 15,
    "name": "SURFACING",
    "start": 5.3,
    "end": 7.79,
    "text": 4
  },
  {
    "id": 16,
    "name": "SURFACING",
    "start": 7.79,
    "end": 11.38,
    "text": 17
  },
  {
    "id": 17,
    "name": "SURFACING",
    "start": 11.38,
    "end": 12.7,
    "text": 1
  },
  {
    "id": 18,
    "name": "SURFACING",
    "start": 12.7,
    "end": 13,
    "text": ""
  },
  {
    "id": 19,
    "name": "SURFACING",
    "start": 13,
    "end": 13.4,
    "text": 13
  },
  {
    "id": 20,
    "name": "ADJ.  RAIL TEMP",
    "start": 0,
    "end": 2.4,
    "text": ""
  },
  {
    "id": 21,
    "name": "ADJ.  RAIL TEMP",
    "start": 2.4,
    "end": 3.5,
    "text": 110
  },
  {
    "id": 22,
    "name": "ADJ.  RAIL TEMP",
    "start": 3.5,
    "end": 13.4,
    "text": ""
  },
  {
    "id": 23,
    "name": "RAIL",
    "start": 0,
    "end": 1.14,
    "text": "15 R-86 L-86"
  },
  {
    "id": 24,
    "name": "RAIL",
    "start": 1.14,
    "end": 1.5,
    "text": "15 RE 2016"
  },
  {
    "id": 25,
    "name": "RAIL",
    "start": 1.5,
    "end": 2.4,
    "text": "15 RE 2015"
  },
  {
    "id": 26,
    "name": "RAIL",
    "start": 2.4,
    "end": 3.5,
    "text": "15 RE 2018"
  },
  {
    "id": 27,
    "name": "RAIL",
    "start": 3.5,
    "end": 3.9,
    "text": "00 AS R-72 L-72"
  },
  {
    "id": 28,
    "name": "RAIL",
    "start": 3.9,
    "end": 4.7,
    "text": "00 AS R-70 L-70"
  },
  {
    "id": 29,
    "name": "RAIL",
    "start": 4.7,
    "end": 5.2,
    "text": "00 AS R-54 L-54"
  },
  {
    "id": 30,
    "name": "RAIL",
    "start": 5.2,
    "end": 5.82,
    "text": "15RE R-93 L-93"
  },
  {
    "id": 31,
    "name": "RAIL",
    "start": 5.82,
    "end": 6.31,
    "text": "00 AS"
  },
  {
    "id": 32,
    "name": "RAIL",
    "start": 6.31,
    "end": 6.91,
    "text": "00RB"
  },
  {
    "id": 33,
    "name": "RAIL",
    "start": 6.91,
    "end": 7.25,
    "text": "15 RE R-93 L-93"
  },
  {
    "id": 34,
    "name": "RAIL",
    "start": 7.25,
    "end": 8.5,
    "text": "15 RE R-83 L-83"
  },
  {
    "id": 35,
    "name": "RAIL",
    "start": 8.5,
    "end": 9.3,
    "text": "15 RE R-93 L-93"
  },
  {
    "id": 36,
    "name": "RAIL",
    "start": 9.3,
    "end": 11.02,
    "text": "15 RE R-83 L-83"
  },
  {
    "id": 37,
    "name": "RAIL",
    "start": 11.02,
    "end": 12.7,
    "text": "15 RE R-83 L-83"
  },
  {
    "id": 38,
    "name": "RAIL",
    "start": 12.7,
    "end": 13,
    "text": "15 RE-13"
  },
  {
    "id": 39,
    "name": "RAIL",
    "start": 13,
    "end": 13.5,
    "text": "15 RE-13"
  },
  {
    "id": 40,
    "name": "BRUSH CUTTING",
    "start": 0,
    "end": 1.5,
    "text": ""
  },
  {
    "id": 41,
    "name": "BRUSH CUTTING",
    "start": 1.5,
    "end": 5.3,
    "text": ""
  },
  {
    "id": 42,
    "name": "BRUSH CUTTING",
    "start": 5.3,
    "end": 8,
    "text": ""
  },
  {
    "id": 43,
    "name": "BRUSH CUTTING",
    "start": 8,
    "end": 12,
    "text": ""
  },
  {
    "id": 44,
    "name": "BRUSH CUTTING",
    "start": 12,
    "end": 13.5,
    "text": ""
  },
  {
    "id": 45,
    "name": "3RD RAIL",
    "start": 0,
    "end": 12.7,
    "text": "150 NMC CWR"
  },
  {
    "id": 46,
    "name": "3RD RAIL",
    "start": 12.7,
    "end": 13.5,
    "text": "84C-2 COMPOSITE"
  }
]};


// WEBPACK FOOTER //
// ./src/components/LampAssets/ViewAssetDetail/linearassets.js